import React from "react";
import { AccordionItem, CustomAccordion } from "../../../components";
import { AppConfig } from "../../../api/config/config";
import DrugIcon from "../../../assets/images/drug_test.png";
import {
  EditPrescriptionDrug,
  PrescriptionDrug,
} from "../../../interface/GeneralResponse";
import { useTranslation } from "react-i18next";
import moment from "moment";

function PrescriptionDetailsAccordion({ data }: { data: any }) {
  const { t } = useTranslation();

  const drugElement = (
    drug: { label: string; value: string | number },
    index: number,
  ) => (
    <div key={index} className="me-6 flex flex-col gap-2">
      <span className="gap-1 text-body-text">{drug?.label}</span>
      <span className="text-wrap text-primary-text">{drug?.value}</span>
    </div>
  );

  const drugDetails = (drug: EditPrescriptionDrug) => [
    {
      label: t("dose"),
      value: drug?.DosageNum
        ? `${drug?.DosageNum} ${drug?.DosageFormUnitName ?? drug?.DosageForm}`
        : t("not_specified"),
    },
    {
      label: t("times"),
      value: drug?.Times || t("not_specified"),
    },
    {
      label: t("duration"),
      value: drug?.Duration || t("not_specified"),
    },
    {
      label: t("medication_period"),
      value: drug?.Meal || t("not_specified"),
    },
    {
      label: t("before_sleep"),
      value: drug?.Sleep ? t("yes") : t("no"),
    },
    {
      label: t("frequency_type"),
      value: drug?.Frequency || t("not_specified"),
    },
  ];

  return (
    <div className="grow overflow-auto rounded-lg border-primary-bg bg-InputFieldColor p-3">
      <CustomAccordion expandAll={false}>
        <h4 className="my-2 text-sm">
          {t("created")}{" "}
          {data?.CreatedAt
            ? moment.unix(parseInt(data?.CreatedAt)).format("DD, MMM YYYY")
            : ""}
        </h4>
        <div className="flex flex-col gap-2">
          {data?.Drugs.map((drug: PrescriptionDrug, i: number) => (
            <div className="rounded-lg bg-white p-3">
              <AccordionItem
                key={drug?.PackageId || i}
                iconClass="!rounded-full"
                totalClass="!border-none"
                titleIcon={AppConfig.SERVER_URL + drug?.Image || DrugIcon}
                title={
                  <div className="flex flex-col justify-center">
                    <h3 className={`text-start font-bold`}>
                      {`${drug?.DrugName || drug?.Name} ${drug?.PackageName}`}
                    </h3>
                    <div className="flex items-center gap-2 text-body-text">
                      <p className="text-sm font-semibold">{drug?.Facility}</p>
                      <span>.</span>
                      <p className="text-sm">{drug?.DosageForm}</p>
                    </div>
                  </div>
                }
                expandAll={false}
              >
                <div className="mb-4 flex flex-wrap gap-4">
                  {drugDetails(drug as any).map((item, index) =>
                    drugElement(item, index),
                  )}
                </div>
                {drugElement(
                  {
                    label: t("instructions"),
                    value: drug?.Instructions || t("not_specified"),
                  },
                  66,
                )}
              </AccordionItem>
            </div>
          ))}
        </div>
      </CustomAccordion>
    </div>
  );
}

export default PrescriptionDetailsAccordion;
